import { render, staticRenderFns } from "./RowInfoQnA.vue?vue&type=template&id=0151fc48&scoped=true"
import script from "./RowInfoQnA.vue?vue&type=script&setup=true&lang=js"
export * from "./RowInfoQnA.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RowInfoQnA.vue?vue&type=style&index=0&id=0151fc48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151fc48",
  null
  
)

export default component.exports